const escapeAttribute = value => String(value).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;')

const BASE_STYLE = `*{box-sizing:border-box}
html,body{margin:0}
body{font:15px/1.6 -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;color:#1f2937;background:#f6f5f3}`

const CHAT_STYLE = `html,body{height:100%;overflow:hidden}
.site{padding:20px 24px}
.site i,.site b,.site p{display:block;margin:0}
.nav{display:flex;align-items:center;gap:10px;margin-bottom:28px}
.nav i{height:8px;width:44px;border-radius:4px;background:#e4e1da}
.nav .logo{width:28px;height:28px;border-radius:8px;background:#d9d5cc;margin-right:auto}
.hero b{height:14px;width:70%;border-radius:6px;background:#dcd8cf;margin-bottom:10px}
.hero b.short{width:45%}
.hero p{height:8px;width:85%;border-radius:4px;background:#e7e4dd;margin-bottom:8px}
.hero p.short{width:60%}
.hero .cta{width:96px;height:28px;border-radius:14px;background:#d9d5cc;margin-top:16px}
.tiles{display:grid;grid-template-columns:repeat(3,1fr);gap:10px;margin-top:28px}
.tiles i{height:84px;border-radius:10px;background:#ebe8e1}`

const CHAT_BODY = `<div class="site" aria-hidden="true">
  <div class="nav"><i class="logo"></i><i></i><i></i><i></i></div>
  <div class="hero"><b></b><b class="short"></b><p></p><p></p><p class="short"></p><i class="cta"></i></div>
  <div class="tiles"><i></i><i></i><i></i></div>
</div>`

const FORM_STYLE = `body{padding:16px}
.card{background:#fff;border:1px solid #e5e7eb;border-radius:12px;padding:20px}`

export const previewPage = (channel, scriptUrl) => {
  const tag = `<script src="${escapeAttribute(scriptUrl)}" data-preview></script>`
  const isChat = channel === 'chat'
  const style = `${BASE_STYLE}\n${isChat ? CHAT_STYLE : FORM_STYLE}`
  const body = isChat ? `${CHAT_BODY}\n${tag}` : `<div class="card">${tag}</div>`

  return `<!doctype html>
<html lang="en">
  <head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <style>${style}</style>
  </head>
  <body>
    ${body}
  </body>
</html>`
}
